import React                        from 'react';
import { Text }                     from '@mantine/core';
import { mapLocationDescLabelText } from '@utils/dxb-utils';
import { CSection }                 from '@core/components/common/CSection';
import useIsMounted                 from '@hooks/use-is-mounted';
import parse                        from 'html-react-parser'
import { Location }                 from '../../../../generated/graphql';


interface Props {
    location: Location;
}

export const LocationDescriptionSection: React.FC<Props> = ({ location }) => {

    const isMounted = useIsMounted();


    return isMounted && (
        <CSection
            // className={} to control content div only
            // change heading styling in the component itself.
            heading={`Discover ${mapLocationDescLabelText(location.address) || '_'}`}
            content={
                <Text size={12} align="justify">
                    {parse(location.description || '_')}
                </Text>
            }
        />
    )

}
